import fetchWrapper from "../../utils/fetchWrapper";

const renewSession = async () => {
  try {
    var response = await fetchWrapper({ url: "/renew" });
    if (response !== true) {
      throw Error("failed to renew session");
    }

    return true;
  } catch (e) {
    console.log(`renew session: ${e}`);
    throw e;
  }
};

export default renewSession;
